import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import ActiveTag from 'components/base/active-tag';
import { PackagingScreenType } from 'models/packaging-screen.model';
import moment from 'moment';

type Props = {
  screen: PackagingScreenType;
  onEdit: (screen?: PackagingScreenType) => void;
};

const PackagingScreenCard = (props: Props) => {
  const { screen, onEdit } = props;

  return (
    <div className='flex flex-col items-start gap-3 p-4 border border-[#EDEDEE] rounded-lg justify-between'>
      <div className='flex flex-col gap-4'>
        <ActiveTag active={screen.active} activeText='Active' inActiveText='Deactivated' />
        <article>
          <p className='text-sm text-[#1A1A1A] font-medium'>{screen.name}</p>
          <p className='text-xs text-[#858585]'>
            Created {moment(screen.created_at).format('MMM D, YYYY, HH:mma')}
          </p>
        </article>

        <div className='flex flex-wrap gap-1'>
          {screen.brands?.length === 0 ? (
            <span className='inline-block text-sm py-1.5 px-3 bg-[#f1f1f1] rounded-full'>
              All brands
            </span>
          ) : (
            screen.brands?.map((item, index) => (
              <img
                key={index}
                src={item.logo}
                alt='logo'
                className='w-8 h-8 object-cover rounded-full -ml-2'
              />
            ))
          )}
        </div>
      </div>
      <Button variant='link' color='primary' onClick={() => onEdit(screen)}>
        Edit screen
      </Button>
    </div>
  );
};

export default PackagingScreenCard;
